import {
    deleteTransactionApi,
    getAccountList,
    interFirmTripDetailsApi,
} from "_services";
import { Images } from "constants";
import images from "constants/images";
import { UserContext } from "context";
import { utils } from "helper";
import {
    AddBankAccount,
    AttachedFileModal,
    BankListCanvas,
    ConfirmModalFor,
    EditInterFirmModal,
    InterFirmAdvancePay,
    PaymentVoucher
} from "modals";

import Loading from "pages/Loading";
import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import StorageService from "utils/StorageServices/StorageServices";
import './consignorFreight.css'
import useDocumentTitle from "hooks/useDocumentTitle";

const InterFirmFreight = (props) => {
    const { freightId, callApi, tripDetais, endTripApiCall } = props;
    const navigate = useNavigate();
    useDocumentTitle("Party Freight | T360");
    const { globTripDetails, setBankDetails, masterData, userSettingPermission } =
        useContext(UserContext);
    const [interFirmTransList, setInterFirmTransList] = useState([]);
    const [interFirmTransDetails, setInterFirmTransDetails] = useState([]);
    const [flag, setFlag] = useState(false);
    const [isOpenCharge, setIsOpenCharges] = useState({ open: false, type: "" });
    const [isOpenFreight, setIsOpenFreight] = useState({ open: false, type: "" });
    const [isOpenClaim, setIsOpenClaim] = useState(false);
    const [canvasOpen, setCanvasOpen] = useState(false);
    const [showAddBank, setShowAddBank] = useState(false);
    const [accountList, setAccountList] = useState([]);
    const [editLrAmount, setEditLrAmount] = useState(false);
    const [editData, setEditData] = useState("");
    const [accountLoading, setAccountLoading] = useState(false);
    const [confirmModalShow, setConfirmModalShow] = useState(false);
    const [transationDetails, setTransationDetails] = useState();
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [showAttachedModal, setShowAttachedModal] = useState({
        open: false,
        data: [],
    });
    const [paymentVoucherOpen, setPaymentVoucherOpen] = useState(false);
    const [advanceFreightList, setAdvanceFreightList] = useState([]);
    const [balanceFreightList, setBalanceFreightList] = useState([]);

    useEffect(() => {
        getInterFirmTransActionHandler(freightId);
        // getAccountListHandler(globTripDetails?.supplier_id?._id);
    }, [freightId, tripDetais]);

console.log(tripDetais)

    useEffect(() => {
        if (transationDetails) {
            setConfirmModalShow(true);
        }
    }, [transationDetails]);

    useEffect(() => {
        if (endTripApiCall === "call") {
            callBackCharge();
        }
    }, [endTripApiCall]);

    const handleDelete = async () => {
        const payload = {
            company_id: StorageService?.getCompanyId(),
            transaction_id: transationDetails?.transaction_id || paymentVoucherOpen?.transaction_id,

        };
        try {
            setDeleteLoading(true);
            const res = await deleteTransactionApi(payload);
            if (res?.responseCode == 200) {
                toast.success(res?.responseMessage);
                setConfirmModalShow(false);
                setTransationDetails("");
                getInterFirmTransActionHandler(freightId);
                callApi();
                setDeleteLoading(false);
                setPaymentVoucherOpen(false)
            } else {
                setDeleteLoading(false);
                // toast.error(res?.responseMessage);
            }
        } catch (error) {
            setDeleteLoading(false);
            toast.error(error?.message);
        }
    };

    const getInterFirmTransActionHandler = async (freightId) => {
        setFlag(true);
        try {
            const res = await interFirmTripDetailsApi({
                company_id: StorageService.getCompanyId(),
                trip_id: freightId,
            });

            if (res?.responseCode === 200) {
                setFlag(false);
                setInterFirmTransDetails(res?.data?.trip_detail);
                setInterFirmTransList(res?.data?.trip_detail?._id);
                setAdvanceFreightList(res?.data.advance_freight);
                setBalanceFreightList(res?.data.balance_freight);

            } else {
                setFlag(false);
            }
        } catch (error) {
            setFlag(false);
        }
    };

    const getAccountListHandler = async (id) => {
        setAccountLoading(false);
        try {
            const res = await getAccountList({
                company_id: StorageService?.getCompanyId(),
                vendor_type: 1,
                vendor_id: id,
            });

            if (res?.responseCode === 200) {
                setAccountLoading(false);
                const details = res?.data?.bank_account?.map((item) => {
                    return {
                        ...item,
                        label: item?.name,
                        value: item?.id,
                    };
                });
                setAccountList(details);
            } else {
                setAccountLoading(false);
            }
        } catch (error) {
        }
    };

    const callBackCharge = () => {

        getInterFirmTransActionHandler(freightId);
        setIsOpenClaim(false);
        // callApi();
        setIsOpenCharges({ open: false, type: "" });
    };

    const callBackAddAccount = () => {
        setCanvasOpen(true);
        getAccountListHandler(globTripDetails?.supplier_id?._id);
    };

    const closeClaimModal = () => {
        setIsOpenClaim(false);
        setBankDetails("");
    };


    const callbackTotal = () => {
        callBackCharge()

    };



    const noTransactionStyle = {
        padding: "10px 0",
        fontSize: "14px",
        color: "#999",
        textAlign: "center",
        borderBottom: "1px solid #ddd",
    };

    const getCategoriesNames = (item) => {
        if (item?.category_type == 1) {
            return <>{item?.categories[0]?.category?.name}</>;
        }

        if (item?.category_type == 2) {
            return <>{item?.category_name}</>;
        }
    };

    const NoTransactionRow = () => (
        <div style={noTransactionStyle}>No Transaction</div>
    );



    let bankListProps = {
        setCanvasOpen: setCanvasOpen,
        canvasOpen: canvasOpen,
        setShowAddBank: setShowAddBank,
        accountList: accountList,
        setIsOpenFreight: setIsOpenClaim,
    };

    const accountClose = () => {
        setShowAddBank(false);
        setCanvasOpen(true);
    };

    let firstAddBank = {
        isOpen: showAddBank,
        closeModal: accountClose,
        headerPart: false,
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: "Add Bank Account",
        submitTitle: "Continue",
        callBackAddAccount: callBackAddAccount,
    };



    let addTotalProps = {
        isOpen: editLrAmount,
        closeModal: (e) => {
            setEditLrAmount(false);
        },
        headerPart: false,
        footerPart: true,
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: "Edit Freight Amount",
        submitTitle: "Update Amount",
        tripId: freightId,
        data: editData,
        setEditData: setEditData,
        icon: images.EDIT,
        callbackTotal: callbackTotal,
    };

    let confirmModalProps = {
        show: confirmModalShow,
        closeModal: (e) => {
            setConfirmModalShow(false);
            setTransationDetails("");
        },
        title: "Confirm",
        submitTitle: "Delete",
        onSubmit: handleDelete,
        confirmModal: "confirmModal",
        icon: Images.DELETEICON.default,
        isLoadding: deleteLoading,
        disabled: deleteLoading,
    };

    let attachedModal = {
        isOpen: showAttachedModal?.open,
        closeModal: (e) =>
            setShowAttachedModal((pre) => ({ ...pre, open: false, data: [] })),
        headerPart: false,
        footerPart: false,
        modalMainClass: "_dashCommon_Modal _AttachmentModal",
        modalTitle: "Attachment",
        submitTitle: "Add",
        cancelButtonTitle: "Cancel",
        showAttachedModal: showAttachedModal,
        // getMaterial: (e) => getMaterial()
        // getBanner: (e) => getBanner()
    };

    const paymentVoucherProps = {
        paymentVoucherOpen: paymentVoucherOpen,
        closeModal: () => setPaymentVoucherOpen(false),
        voucherId: paymentVoucherOpen?._id,
        oprnDeleteModal: setConfirmModalShow
    };


    let freightpayProps = {
        isOpen: isOpenFreight?.open,
        isOpenFreight: isOpenFreight,
        setCanvasOpen: setCanvasOpen,
        canvasOpen: canvasOpen,
        // modalType: isOpenExpense.type,
        closeModal: (e) =>
            setIsOpenFreight({ ...isOpenFreight, open: false, type: "" }),
        // closeModal: (e) => setIsOpenFreight(false),
        headerPart: false,
        footerPart: true,
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: "Add Freight",
        submitTitle: "Add Freight",
        cancelButtonTitle: "Send for Approval",
        tripId: freightId,
        callBackFreight: callbackTotal,
        // transactionList: transactionList,
        accountList: accountList,
        setIsOpenFreight: setIsOpenFreight,
        // userPermission: userPermission?.supplier_freight,
        userSettingPermission: userSettingPermission,
        // venderDetailsFun: venderDetailsFun
        interFirmTransDetails:interFirmTransDetails
    };

    const renderTransactionRow = (transaction) => {
        return (
            <tr key={transaction._id}>
                <td>
                    <span>{new Date(transaction.date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</span>
                    <br />
                    <div>Date</div>
                </td>
                <td>
                    <span className="sameSpan">{transaction.voucher_no || 'N/A'}</span>
                    <br />
                    <div>Voucher</div>
                </td>
                <td>
                    <span className="sameSpan fw-400">
                        <div>{transaction.description || 'Payment'}</div>
                        <div>{transaction.route_name || ''} | {transaction.trip_no || ''}</div>
                    </span>
                </td>
                <td className="sameSpan">
                    {transaction.category_name || 'N/A'}
                    <div>Category</div>
                </td>
                <td className="sameSpan">
                    <div>Bank Account</div>
                    <div className="fBold">{transaction.from_account?.name || 'N/A'}</div>
                    <div>From Account</div>
                </td>
                <td>
                    <div>Consignor</div>
                    <div className="fBold">{transaction.to_account?.name || 'N/A'}</div>
                    <div>To Account</div>
                </td>
                <td>
                    <div style={{ textAlign: "right", paddingRight: "6px" }}>
                        <span className="sameSpan">₹ {Number(transaction.amount || 0).toFixed(2)}</span>
                    </div>
                </td>
                <td align="right">
                    <div className="_rSide_drp">
                        <button className="dropbtn11">⋮</button>
                    </div>
                </td>
            </tr>
        );
    };

    const renderNoTransactions = () => {
        return (
            <tr>
                <td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>
                    No transactions available
                </td>
            </tr>
        );
    };



    return (
        <>
            {interFirmTransDetails?.branch_firm?.firm ? (
                <div className="anv_tripTab_otr">
                    <div className="row anvRG_gap">
                        <div className="col-12">
                            <div className="anvFrightUpp_tabBx_tp" style={{ paddingBottom: '0px' }}>
                                <div className="anvFrightInden_detailBx_tp">

                                    <div className="sprt_dix _nwDix_sprt"> <div className="_anvFix_bs">
                                        <p>
                                            Tyres{" "}
                                            {`${interFirmTransDetails?.lorry_type_id?.lorry_type
                                                ? interFirmTransDetails?.lorry_type_id?.lorry_type
                                                : ""
                                                } > ${interFirmTransDetails?.vehicle_type_id?.name
                                                    ? interFirmTransDetails?.vehicle_type_id?.name
                                                    : ""
                                                }`}
                                        </p>
                                        <h2>
                                            {interFirmTransDetails?.vehicle_id?.vehicle_no && (
                                                <>
                                                    {interFirmTransDetails?.vehicle_id?.vehicle_no.length === 9
                                                        ? // Case when length is 9, middle part is one digit
                                                        interFirmTransDetails?.vehicle_id?.vehicle_no.slice(0, 4) +
                                                        " " +
                                                        interFirmTransDetails?.vehicle_id?.vehicle_no.slice(4, 5) +
                                                        " " +
                                                        interFirmTransDetails?.vehicle_id?.vehicle_no.slice(5)
                                                        : // Case when length is 10, middle part is two digits
                                                        interFirmTransDetails?.vehicle_id?.vehicle_no.slice(0, 4) +
                                                        " " +
                                                        interFirmTransDetails?.vehicle_id?.vehicle_no.slice(4, 6) +
                                                        " " +
                                                        interFirmTransDetails?.vehicle_id?.vehicle_no.slice(6)}{" "}
                                                    <span
                                                        className={
                                                            interFirmTransDetails?.vehicle_ownership === 1
                                                                ? "_trkMark _lrDelivered_status"
                                                                : interFirmTransDetails?.vehicle_ownership === 2
                                                                    ? "_trkMark _lrPartyPoint_status"
                                                                    : "_trkMark _lrInTransit_status"
                                                        }
                                                    >
                                                        {
                                                            masterData?.vehicle_ownership_list?.find(
                                                                (i) => i.id === interFirmTransDetails?.vehicle_ownership
                                                            )?.name
                                                        }
                                                    </span>
                                                </>
                                            )}
                                        </h2>
                                    </div></div>

                                </div>
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="anv_freightTable_otr_tpBx _anvfrg_table">
                                <div className="anv_freightTable_detail_tpBx" style={{ width: '100%', maxWidth: '1250px' }}>
                                    <div className="accordionTable_view">
                                        <style>
                                            {`
      .accordion-button:not(.collapsed) .cstCevs {
        transform: rotate(180deg);
        transition: transform 0.3s ease;
      }
      .accordion-button.collapsed .cstCevs {
        transform: rotate(0deg);
        transition: transform 0.3s ease;
      }
      .accordion-button svg {
        transition: transform 0.3s ease;
      }
      .accordion-button:not(.collapsed) svg {
        transform: rotate(180deg);
      }
    `}
                                        </style>

                                        <div className="accordion" id="accordionitem">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <div className="PickNdrop_placeBx">
                                                        <div className="_cnFr_listsBx">
                                                            <div>
                                                                {(interFirmTransDetails?.branch_firm?.firm && interFirmTransDetails?.vehicle_firm?.firm) && <div className="_pdTransport_dl">
                                                                    <h5 style={{ cursor: "pointer" }}>
                                                                        <h5 style={{
                                                                            fontSize: '13px',
                                                                            fontWeight: 400,
                                                                            lineHeight: '1.4'
                                                                        }}>
                                                                            <span style={{ fontWeight: 400 }}>Freight Payable</span>
                                                                            {' '}to{' '}
                                                                            <span style={{ fontWeight: 700 }}> {interFirmTransDetails?.vehicle_firm?.firm} </span>
                                                                            {' '}from{' '}
                                                                            <span style={{ fontWeight: 700 }}> {interFirmTransDetails?.branch_firm?.firm}</span>
                                                                        </h5>
                                                                    </h5>
                                                                </div>}
                                                            </div>

                                                            <div className="_flxRight" style={{ alignItems: 'center' }}>
                                                                <span className="tagBxs pending">Bill Pending</span>
                                                                <button
                                                                    className="anime-btn __extendEw_btn"
                                                                    style={{ marginLeft: '6px', marginRight: '10px' }}
                                                                >
                                                                    Raise Bill
                                                                </button>

                                                                <button
                                                                    className="accordion-button"
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#collapseOne"
                                                                    aria-expanded="true"
                                                                    aria-controls="collapseOne"
                                                                >
                                                                    <svg
                                                                        className="cstCevs"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="18"
                                                                        height="18"
                                                                        viewBox="0 0 18 18"
                                                                        fill="none"
                                                                    >
                                                                        <path
                                                                            d="M4.91862 6.69936C4.87178 6.6502 4.81668 6.61176 4.75647 6.58625C4.69625 6.56074 4.63211 6.54865 4.56769 6.55068C4.50327 6.5527 4.43984 6.5688 4.38102 6.59805C4.3222 6.6273 4.26915 6.66913 4.22488 6.72116C4.18062 6.77319 4.14602 6.83439 4.12305 6.90127C4.10008 6.96815 4.08919 7.0394 4.09102 7.11095C4.09284 7.18251 4.10733 7.25296 4.13367 7.31829C4.16 7.38362 4.19767 7.44255 4.24451 7.49172L8.6601 12.1238C8.75119 12.2194 8.87179 12.2727 8.99715 12.2727C9.12251 12.2727 9.24312 12.2194 9.33421 12.1238L13.7503 7.49172C13.7982 7.44288 13.8368 7.38396 13.864 7.31839C13.8912 7.25282 13.9064 7.1819 13.9087 7.10975C13.911 7.0376 13.9004 6.96566 13.8774 6.89811C13.8545 6.83056 13.8197 6.76875 13.7751 6.71626C13.7305 6.66377 13.6769 6.62165 13.6175 6.59235C13.5581 6.56305 13.494 6.54715 13.4291 6.54558C13.3641 6.54401 13.2995 6.5568 13.239 6.5832C13.1785 6.60959 13.1233 6.64908 13.0767 6.69936L8.99715 10.9783L4.91862 6.69936Z"
                                                                            fill="#1450EC"
                                                                        />
                                                                        <circle
                                                                            cx="9"
                                                                            cy="9"
                                                                            r="8.59091"
                                                                            transform="rotate(-180 9 9)"
                                                                            stroke="#0049D7"
                                                                            strokeWidth="0.818182"
                                                                        />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </h2>

                                                <div
                                                    id="collapseOne"
                                                    className="accordion-collapse collapse show"
                                                    data-bs-parent="#accordionConFright"
                                                >
                                                    <div className="__nW_tblSpx">
                                                        <div className="anv_fr_detailHead">
                                                            <div className="accordion" id="accordionPanelsStayOpenExample">

                                                                <div id="panelsStayOpen-headingOne">
                                                                    <h4 style={{ minHeight: '43px', paddingRight: '1em' }}>
                                                                        <div className="_nW_h4Inner">
                                                                            <p className="__avgFrieght">Total Freight</p>
                                                                        </div>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                                                            <span className="__rtAmt">
                                                                                ₹ {Number(interFirmTransDetails?.firm_freight_summary?.total_freight || 0).toFixed(2)}
                                                                            </span>

                                                                            <button onClick={() => {

                                                                                if (tripDetais?.trip_status != 5) {
                                                                                    setEditData(interFirmTransDetails);
                                                                                    setEditLrAmount(true);
                                                                                }

                                                                            }}>
                                                                                <svg
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    width="17"
                                                                                    height="17"
                                                                                    viewBox="0 0 17 17"
                                                                                    fill="none"
                                                                                >
                                                                                    <path
                                                                                        d="M3.64706 4.52942H2.76471C2.29668 4.52942 1.84782 4.71534 1.51687 5.04629C1.18592 5.37724 1 5.8261 1 6.29413V14.2353C1 14.7033 1.18592 15.1522 1.51687 15.4831C1.84782 15.8141 2.29668 16 2.76471 16H10.7059C11.1739 16 11.6228 15.8141 11.9537 15.4831C12.2847 15.1522 12.4706 14.7033 12.4706 14.2353V13.353"
                                                                                        stroke="#0049D7"
                                                                                        strokeWidth="1.76469"
                                                                                        strokeLinecap="round"
                                                                                        strokeLinejoin="round"
                                                                                    />
                                                                                    <path
                                                                                        d="M11.5881 2.7648L14.2352 5.41186M15.4572 4.16333C15.8047 3.81582 16 3.34449 16 2.85304C16 2.36158 15.8047 1.89025 15.4572 1.54274C15.1097 1.19523 14.6384 1 14.1469 1C13.6555 1 13.1841 1.19523 12.8366 1.54274L5.41162 8.94128V11.5883H8.05868L15.4572 4.16333Z"
                                                                                        stroke="#0049D7"
                                                                                        strokeWidth="1.76469"
                                                                                        strokeLinecap="round"
                                                                                        strokeLinejoin="round"
                                                                                    />
                                                                                </svg>
                                                                            </button>
                                                                        </div>
                                                                    </h4>

                                                                    <h4>
                                                                        <div className="_nW_h4Inner">
                                                                            <p className="__avgFrieght">Advance Freight</p>
                                                                            <button className="addAble_btn addClaim" onClick={() =>  setIsOpenFreight({ open: interFirmTransDetails, type: "freight" })}>
                                                                                <div className="_otrIcon_imb">
                                                                                    <img src={images.RUPEE} alt="" />
                                                                                </div>
                                                                                <span>Add Freight</span>
                                                                            </button>
                                                                        </div>

                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                                                            <span className="__rtAmt"> ₹ {Number(interFirmTransDetails?.firm_freight_summary?.advance_freight || 0).toFixed(2)}</span>
                                                                            <button
                                                                                className="accordion-button collapsed"
                                                                                type="button"
                                                                                data-bs-toggle="collapse"
                                                                                data-bs-target="#panelsStayOpen-collapseOne"
                                                                                aria-expanded="false"
                                                                            >
                                                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                                    <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="2" />
                                                                                </svg>
                                                                            </button>
                                                                        </div>
                                                                    </h4>

                                                                    <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse">
                                                                        <div className="accordion-body">
                                                                            <table className="ctmTable _trpTable_xd __nwdChn_flxTb">
                                                                                <tbody>
                                                                                    {advanceFreightList && advanceFreightList.length > 0
                                                                                        ? advanceFreightList.map(renderTransactionRow)
                                                                                        : renderNoTransactions()}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>



                                                                <div id="panelsStayOpen-headingThree">
                                                                    <h4>
                                                                        <div className="_nW_h4Inner">
                                                                            <p className="__avgFrieght">Balance Freight</p>
                                                                            <button className="addAble_btn addClaim" onClick={() =>  setIsOpenFreight({ open: interFirmTransDetails, type: "freightBalance" })}>
                                                                                <div className="_otrIcon_imb">
                                                                                    <img src={images.RUPEE} alt="" />
                                                                                </div>
                                                                                <span>Add Balance</span>
                                                                            </button>
                                                                        </div>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                                                            <span className="__rtAmt"> ₹ {Number(interFirmTransDetails?.firm_freight_summary?.balance_freight || 0).toFixed(2)}</span>
                                                                            <button
                                                                                className="accordion-button collapsed"
                                                                                type="button"
                                                                                data-bs-toggle="collapse"
                                                                                data-bs-target="#panelsStayOpen-collapseThree"
                                                                                aria-expanded="false"
                                                                            >
                                                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                                    <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="2" />
                                                                                </svg>
                                                                            </button>
                                                                        </div>
                                                                    </h4>

                                                                    <div id="panelsStayOpen-collapseThree" className="accordion-collapse collapse">
                                                                        <div className="accordion-body">
                                                                            <table className="ctmTable _trpTable_xd __nwdChn_flxTb">
                                                                                <tbody>
                                                                                    {balanceFreightList && balanceFreightList.length > 0
                                                                                        ? balanceFreightList.map(renderTransactionRow)
                                                                                        : renderNoTransactions()}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <h4 style={{ borderBottom: "1px solid #d9e6ef", paddingRight: '3.26em' }}>
                                                                Total TDS <span className="__rtAmt"> ₹ {Number(interFirmTransDetails?.firm_freight_summary?.total_tds || 0).toFixed(2)}</span>
                                                            </h4>

                                                            {/* <h4 style={{ borderBottom: "1px solid #d9e6ef", paddingRight: '3.26em' }}>
                                                                GST <span className="__rtAmt">₹ 0.00</span>
                                                            </h4> */}

                                                            <h4 style={{ borderBottom: "1px solid #d9e6ef", paddingRight: '3.26em' }}>
                                                                Balance <span className="__rtAmt">₹ {Number(interFirmTransDetails?.firm_freight_summary?.balance || 0).toFixed(2)}</span>
                                                            </h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>




                            </div>
                        </div>
                    </div>
                </div>
            ) : flag ? (
                <div className="loaderBg" style={{ textAlign: "center" }}><Loading /></div>
            ) : (
                <>No Data</>
            )}


            {canvasOpen && <BankListCanvas {...bankListProps} />}
            {showAddBank && <AddBankAccount {...firstAddBank} />}
            {editLrAmount && <EditInterFirmModal {...addTotalProps} />}
            {showAttachedModal?.open && <AttachedFileModal {...attachedModal} />}
            {isOpenFreight?.open && <InterFirmAdvancePay {...freightpayProps} />}

            {confirmModalShow && (
                <ConfirmModalFor {...confirmModalProps}>
                    <>
                        <p className="_confirmPrx">
                            {" "}
                            Are you sure you want to delete " {"Transaction"} "{" "}
                        </p>
                    </>
                </ConfirmModalFor>
            )}

            {paymentVoucherOpen && <PaymentVoucher {...paymentVoucherProps} />}
        </>
    );
};

export default InterFirmFreight;
